import { createEnvConfig } from "@ews-admin/global-design-system";

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PHONE_REGEX =
  /^\+?(\(?[1-9]\d{0,2}?\)?)[ -.]?(\(?\d{1,4}?\)?[ -.]?)?\d{1,4}([ -.]?\d{1,4}){1,2}$/;
export const envConfig = createEnvConfig(import.meta.env.VITE_ENV, {
  ...(import.meta.env.VITE_MEDECINE360_BFF_URL && {
    bffUrl: import.meta.env.VITE_MEDECINE360_BFF_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_LOGIN_BFF_URL && {
    loginBffUrl: import.meta.env.VITE_MEDECINE360_LOGIN_BFF_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_APP_URL && {
    appUrl: import.meta.env.VITE_MEDECINE360_APP_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_LOGIN_URL && {
    loginUrl: import.meta.env.VITE_MEDECINE360_LOGIN_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_DASHBOARD_URL && {
    dashboardUrl: import.meta.env.VITE_MEDECINE360_DASHBOARD_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_ADMIN_URL && {
    adminUrl: import.meta.env.VITE_MEDECINE360_ADMIN_URL,
  }),
});

export const getLoginApplicationUrl = () => envConfig.loginUrl;
export const getApplicationUrl = () => envConfig.appUrl;
export const getApplicationApiUrl = () => envConfig.bffUrl;
export const getLoginApiUrl = () => envConfig.loginBffUrl;
export const isLocalEnv = () => envConfig.env === "local";
export const isProdEnv = () => envConfig.env === "prod";
export const getAuthUrl = () => envConfig.loginUrl;
export const getDashboardUrl = () => envConfig.dashboardUrl;
export const getAdminUrl = () => envConfig.adminUrl;

export const getFieldsErrorMessage = (
  fields: { name: string; message: string }[]
): string => {
  return fields.map(field => `${field.name}: ${field.message}`).join(", ");
};

export const getFirebaseApiKey = () => {
  return import.meta.env.VITE_FIREBASE_API_KEY;
};

export const getFirebaseAuthDomain = () => {
  return import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
};

export const getFirebaseProjectId = () => {
  return import.meta.env.VITE_FIREBASE_PROJECT_ID;
};

export const getFirebaseStorageBucket = () => {
  return import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
};

export const getFirebaseMessagingSenderId = () => {
  return import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID;
};

export const getFirebaseAppID = () => {
  return import.meta.env.VITE_FIREBASE_APP_ID;
};
